import {
  AutopilotTaskDto,
  TaskCategoryTaskType,
} from '@urbanx/agx.activities.client'
import { JSX, ReactNode } from 'react'
import { LaunchTaskBlocker } from './LaunchTaskBlocker'
import { PendingTaskBlocker } from './PendingTaskBlocker'
import { PreLaunchTaskBlocker } from './PreLaunchTaskBlocker'

type TaskBlockerProps = {
  task: AutopilotTaskDto
  children: ReactNode
  onTasksInvalidated?: () => void
}

export const TaskBlocker = ({
  task,
  children,
  onTasksInvalidated,
}: TaskBlockerProps): JSX.Element | null => {
  if (!task.category) return null

  const defaultContent = task.isPending
    ? <PendingTaskBlocker task={task} />
    : <>{children}</>

  switch (task.category.taskType) {
    case TaskCategoryTaskType.PreLaunch:
      return (
        <PreLaunchTaskBlocker task={task}>{defaultContent}</PreLaunchTaskBlocker>
      )

    case TaskCategoryTaskType.Launch:
      return (
        <LaunchTaskBlocker task={task} onTasksInvalidated={onTasksInvalidated}>
          {defaultContent}
        </LaunchTaskBlocker>
      )
    case TaskCategoryTaskType.Unconditional:
      return defaultContent

    default:
      return defaultContent
  }
}
